var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.02 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#1d1d24;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.51,5.27a1.51,1.51,0,0,1,1.06.44,1.42,1.42,0,0,1,.45,1v7.52a1.4,1.4,0,0,1-.45,1,1.51,1.51,0,0,1-1.06.44h-9a1.47,1.47,0,0,1-1-.44,1.38,1.38,0,0,1-.46-1V6.75a1.39,1.39,0,0,1,.46-1,1.47,1.47,0,0,1,1.05-.44h.74V3.76A3.61,3.61,0,0,1,3.36,1.11,3.61,3.61,0,0,1,6,0,3.63,3.63,0,0,1,8.67,1.11a3.64,3.64,0,0,1,1.1,2.65V5.27Zm-2.18,0V3.76a2.24,2.24,0,0,0-.68-1.63A2.25,2.25,0,0,0,6,1.44a2.21,2.21,0,0,0-1.63.69,2.21,2.21,0,0,0-.69,1.63V5.27ZM5,11.57A1.44,1.44,0,0,0,6,12a1.54,1.54,0,0,0,1.51-1.51,1.44,1.44,0,0,0-.45-1A1.45,1.45,0,0,0,6,9a1.41,1.41,0,0,0-1,.46,1.41,1.41,0,0,0-.46,1A1.45,1.45,0,0,0,5,11.57Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.9e1a616a43276503e713227edc105572.svg";
export { ForwardRef as ReactComponent };